<template>
  <ConfirmationModal
    :title="$t('DELETE_BULK_TAGS_CONFIRMATION_TITLE')"
    :entity="bulkTags"
    :show-confirm-button="true"
    :show-cancel-button="true"
    :cancel-button-text="$t('CANCEL')"
    :confirm-action-text="$t('DELETE')"
    :confirm-button-disabled="disableModalConfirm"
    :confirm-button-loading="deletingBulkTags"
    @close="closeModal"
    @confirm="deleteBulkTags"
  >
    <div v-if="getBulkTagsReferencesStatus.status == 'pending'">
      <Loader custom-class="size-sm" />
      <span v-html="$t('DELETE_BULK_TAGS_MODAL_CHECK_ASSOCIATION_TEXT', { bulkTagsToDeleteName })" />
    </div>
    <div v-if="getBulkTagsReferencesStatus.status == 'success'">
      <p v-if="!hasReferences"
         v-html="$t('DELETE_BULK_TAGS_MODAL_TEXT', { bulkTagsToDeleteName })" />
      <p 
        v-if="!hasReferences"
        v-html="$t('DELETE_BULK_TAGS_MODAL_NONE_ASSOCIATION_TEXT', { bulkTagsToDeleteName })"
      />
      <div v-else>
        <p
          class="m-b-10"
          v-html="$t('DELETE_BULK_TAGS_MODAL_ASSOCIATION_TEXT', { bulkTagsToDeleteName })"
        />
        <div class="well well-sm m-b-10">
          <div class="form-horizontal">
            <div
              v-for="(value, type) in groupedReferences"
              class="row"
            >
              <label class="col-md-3 control-label">
                <strong>{{ type + 's' }}</strong>
              </label>
              
              <div class="col-md-8">
                <ul class="list-unstyled form-control-static list-text-overflow">
                  <li v-for="(item, index) in value">
                    <a
                      :href="item.link"
                      target="_blank"
                    >
                      <span
                        class="display-text"
                        :title="item.name"
                      >
                        {{ item.name }}
                      </span>
                      <i
                        class="fa fa-external-link m-l-5"
                        aria-hidden="true"
                      />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="form-horizontal m-l-10 m-r-10">
          <div class="checkbox">
            <span v-t="'DELETE_BULK_TAGS_ATTEST_PRE'"></span>
            <label class="m-t-10">
              <input
                v-model="forceDelete"
                type="checkbox"
                @change="attestDelete"
              >
              <span v-t="'DELETE_BULK_TAGS_ATTEST'" />
            </label>
          </div>
        </div>
      </div>
    </div>
    <div v-if="getBulkTagsReferencesStatus.status == 'error'">
      <div
        v-t="'DELETE_BULK_TAGS_MODAL_CHECK_ASSOCIATION_ERROR_TEXT'"
        class="bs-callout bs-callout-danger"
      />
    </div>
  </ConfirmationModal>
</template>

<script>
import { mapGetters } from 'vuex';
import messages from '../../locales';
import sharedMessages from '@/core/locales';
import Loader from '@/core/components/Loader';
import ConfirmationModal from '@/core/components/ConfirmationModal/ConfirmationModal';

export default {
  name: 'BulkTagsDeleteModal',
  components: {
    Loader,
    ConfirmationModal
  },
  props:{
    bulkTags: {
      type: Object,
      default() {
        return {};
      }
    },
    references: {
      type: Array,
      default() {
        return [];
      }
    },
    disableModalConfirm: {
      type: Boolean,
      default: false
    },
    deletingBulkTags: {
      type: Boolean,
      default: false
    },
    hasReferences: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      forceDelete: false,
    };
  },
  computed: {
    ...mapGetters('bulkTags', [
      'getBulkTagsReferencesStatus'
    ]),
    groupedReferences() {
      const groupBy = (input, key) => {
        return input.reduce((acc, currentValue) => {
          const groupKey = currentValue[key];
          if (!acc[groupKey]) {
            acc[groupKey] = [];
          }
          acc[groupKey].push(currentValue);
          return acc;
        }, {});
      };
      return groupBy(this.references, 'type');
    },
    bulkTagsToDeleteName() {
      return this.bulkTags?.name;
    }
  },
  methods:{
    closeModal() {
      this.$emit('closeModal');
    },
    deleteBulkTags() {
      this.$emit('deleteBulkTags', this.bulkTags);
    },
    attestDelete() {
      this.$emit('attestDelete', this.forceDelete);
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>